import React, { useEffect, useState } from "react";
import { TabContent, TabPane } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";

import {
  addAttachmentCategoryTypeSuccess,
  addNewAttachmentCategoryType,
  deleteAttachmentCategoryType,
  deleteAttachmentCategoryTypeSuccess,
  getAttachmentCategoryTypeData,
  updateAttachmentCategoryType,
  updateAttachmentCategoryTypeSuccess,
} from "../../../../store/attachmentCategoryType/actions";

import { isEmpty } from "lodash";
import "../../settings.styles.css";
import StatusViewEditComponent from "../components/statusViewEditComponent";
import SettingsPanel from "../../components/SettingsPanel";
import { toast } from "react-toastify";
import DeleteModal from "../../../../Components/Common/DeleteModal";

export default function AttachmentSettings() {
  const dispatch = useDispatch();

  const { attachmentCategoryTypeList } = useSelector((state) => ({
    attachmentCategoryTypeList:
      state.AttachmentCategoryType.attachmentCategoryTypeList
        ?.attachmentcategorytype_list ??
      state.AttachmentCategoryType.attachmentCategoryTypeList
        ?.jobattachmenttype_list,
  }));

  const [statusList, setStatusList] = useState([]);
  const [activeTab, setActiveTab] = useState("1");
  const [deleteStatus, setDeleteStatus] = useState("");
  const [createStatus, setCreateStatus] = useState({
    Name: "New Status",
    CssColourText: "#000000",
    CssColourBackground: "#F4F0F0",
    FlagActive: null,
    FlagInvoiceable: null,
  });
  const [updateItemStatus, setUpdateItemStatus] = useState({});

  const handleCreateNewStatus = () => {
    // Attachment Category Type create
    dispatch(addNewAttachmentCategoryType([createStatus]));
  };

  // Attachment Category Type create
  const { attachmentCategoryTypeCreateSuccessAPI } = useSelector((state) => ({
    attachmentCategoryTypeCreateSuccessAPI:
      state.AttachmentCategoryType.attachmentCategoryTypeCreateSuccess,
  }));

  useEffect(() => {
    if (isEmpty(attachmentCategoryTypeCreateSuccessAPI)) return;
    if (attachmentCategoryTypeCreateSuccessAPI.status === 200) {
      toast.success(attachmentCategoryTypeCreateSuccessAPI.message);
      dispatch(getAttachmentCategoryTypeData());
      setCreateStatus({
        Name: "New Status",
        CssColourText: "#000000",
        CssColourBackground: "#F4F0F0",
        FlagActive: null,
        FlagInvoiceable: null,
      });
    } else {
      toast.error(attachmentCategoryTypeCreateSuccessAPI.message);
    }
    dispatch(addAttachmentCategoryTypeSuccess([]));
  }, [attachmentCategoryTypeCreateSuccessAPI]);

  const handleDeleteStatus = () => {
    // Attachment Category Type delete
    dispatch(deleteAttachmentCategoryType([deleteStatus]));
  };

  //Delete Attachment Category Type
  const { attachmentCategoryTypeDeleteAPI } = useSelector((state) => ({
    attachmentCategoryTypeDeleteAPI:
      state.AttachmentCategoryType.attachmentCategoryTypeDelete,
  }));

  useEffect(() => {
    if (isEmpty(attachmentCategoryTypeDeleteAPI)) return;
    if (attachmentCategoryTypeDeleteAPI.status === 200) {
      toast.success(attachmentCategoryTypeDeleteAPI.message);
      dispatch(getAttachmentCategoryTypeData());
      setDeleteModal(false);
    } else {
      toast.error(attachmentCategoryTypeDeleteAPI.message);
    }
    dispatch(deleteAttachmentCategoryTypeSuccess([]));
  }, [attachmentCategoryTypeDeleteAPI]);

  // Sort Data
  useEffect(() => {
    setStatusList(attachmentCategoryTypeList?.sort((a, b) => b.Id - a.Id));
  }, [attachmentCategoryTypeList]);

  useEffect(() => {
    dispatch(getAttachmentCategoryTypeData());
  }, []);

  const Tabs = [
    {
      id: "1",
      name: "Attachment Category Types",
    },
  ];
  const [deleteModal, setDeleteModal] = useState(false);

  // Update Module
  useEffect(() => {
    if (isEmpty(updateItemStatus)) return;
    let updateNewStatus = {
      Id: updateItemStatus?.Id,
      Name: updateItemStatus?.Name,
      Description: updateItemStatus?.Description,
      CssColourBackground: updateItemStatus?.CssColourBackground,
      CssColourBorder: updateItemStatus?.CssColourBorder,
      CssColourText: updateItemStatus?.CssColourText,
      Order: updateItemStatus?.Order,
      FlagActive: updateItemStatus?.FlagActive,
    };
    const delayUpdate = setTimeout(() => {
      // Attachment Category Type update
      dispatch(updateAttachmentCategoryType([updateNewStatus]));
    }, 500);
    return () => clearTimeout(delayUpdate);
  }, [updateItemStatus]);

  // Update Attachment Category Type
  const { attachmentCategoryTypeUpdateAPI } = useSelector((state) => ({
    attachmentCategoryTypeUpdateAPI:
      state.AttachmentCategoryType.attachmentCategoryTypeUpdate,
  }));
  useEffect(() => {
    if (isEmpty(attachmentCategoryTypeUpdateAPI)) return;
    if (attachmentCategoryTypeUpdateAPI.status === 200) {
      toast.success(attachmentCategoryTypeUpdateAPI.message);
      dispatch(getAttachmentCategoryTypeData());
    } else {
      toast.error(attachmentCategoryTypeUpdateAPI.message);
    }
    dispatch(updateAttachmentCategoryTypeSuccess([]));
  }, [attachmentCategoryTypeUpdateAPI]);

  return (
    <>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteStatus}
        onCloseClick={() => {
          setDeleteModal(false);
        }}
      />
      <SettingsPanel
        title="Attachment Settings"
        description="Category types for attachments across jobs and tasks"
        tabs={Tabs.map((item) => ({ value: item.id, label: item.name }))}
        value={activeTab}
        onChange={setActiveTab}
      >
        <TabContent activeTab={activeTab} className="pt-4">
          <TabPane tabId="1">
            <StatusViewEditComponent
              statusList={statusList}
              setStatusList={setStatusList}
              createStatus={createStatus}
              setCreateStatus={setCreateStatus}
              handleCreateNewStatus={handleCreateNewStatus}
              setDeleteStatus={setDeleteStatus}
              setDeleteModal={setDeleteModal}
              setUpdateItemStatus={setUpdateItemStatus}
              statusFlag={false}
            />
          </TabPane>
        </TabContent>
      </SettingsPanel>
    </>
  );
}
